import apiFetch from '../../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `ControlSemen/etiquetasControlSemen`, method: 'POST', body: values, token: token})
}